import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';

@Pipe({
  name: 'utcToLocalTime',
  standalone: true,
})
export class UtcToLocalTimePipe implements PipeTransform {
  transform(value: string | Date): string {
    if (!value) {
      return '';
    }
    const UTC_DATE = new Date(value);
    const LOCAL_DATE = new Date(
      UTC_DATE.getUTCFullYear(),
      UTC_DATE.getUTCMonth(),
      UTC_DATE.getUTCDate(),
      UTC_DATE.getUTCHours(),
      UTC_DATE.getUTCMinutes(),
      UTC_DATE.getUTCSeconds()
    );
    return LOCAL_DATE.toLocaleTimeString('en-GB', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });
  }
}
